<div class="card">
  <div class="card-header">
    <div class="d-flex flex-wrap justify-content-between align-items-center w-100">
      <div>
        <h3 class="fw-bold my-2">{{ 'companyProfile.services.title' | translate }}</h3>
        <p class="text-muted mb-0">{{ 'companyProfile.services.subtitle' | translate }}</p>
      </div>
      <app-button
        [variant]="'primary'"
        [label]="'companyProfile.services.addService' | translate"
        [iconClass]="'fa fa-plus'"
        (clicked)="openAddModal()"
      />
    </div>
  </div>
  <div class="card-body">
    @if (loading) {
      <div class="d-flex justify-content-center align-items-center py-10">
        <div class="spinner-border text-primary" role="status">
          <span class="visually-hidden">{{ 'companyProfile.services.loading' | translate }}</span>
        </div>
      </div>
    } @else if (services.length === 0) {
      <div class="text-center py-15">
        <i class="fa fa-boxes-stacked fs-3x text-muted mb-5"></i>
        <h4 class="text-muted">{{ 'companyProfile.services.noServices' | translate }}</h4>
        <p class="text-muted mb-5">{{ 'companyProfile.services.noServicesHint' | translate }}</p>
        <app-button
          [label]="'companyProfile.services.addService' | translate"
          [variant]="'primary'"
          [iconClass]="'fa fa-plus'"
          (clicked)="openAddModal()"
        />
      </div>
    } @else {
      <div class="table-responsive">
        <table class="table table-row-bordered align-middle gy-4">
          <thead>
            <tr class="fw-bold text-muted bg-light">
              <th class="ps-4 rounded-start">{{ 'companyProfile.services.name' | translate }}</th>
              <th>{{ 'companyProfile.services.description' | translate }}</th>
              <th class="text-end">{{ 'companyProfile.services.price' | translate }}</th>
              <th class="text-center">{{ 'companyProfile.services.vat' | translate }}</th>
              <th class="text-end rounded-end pe-4">{{ 'companyProfile.services.actions' | translate }}</th>
            </tr>
          </thead>
          <tbody>
            @for (service of services; track service.service_id) {
              <tr>
                <td class="ps-4">
                  <span class="fw-bold text-dark">{{ service.service_name }}</span>
                </td>
                <td>
                  <span class="text-muted">{{ service.service_description || '-' }}</span>
                </td>
                <td class="text-end">
                  <span class="fw-bold">{{ formatPrice(service.price_cents) }} {{ service.currency }}</span>
                </td>
                <td class="text-center">
                  <span class="badge badge-light-secondary">{{ getVatLabel(service.vat_rate) }}</span>
                </td>
                <td class="text-end pe-4">
                  <div class="d-flex justify-content-end gap-2">
                    <app-button
                      [variant]="'ghost'"
                      [iconClass]="'fa fa-edit'"
                      [size]="'sm'"
                      (clicked)="openEditModal(service)"
                    />
                    <app-button
                      [variant]="'ghost'"
                      [iconClass]="'fa fa-trash text-danger'"
                      [size]="'sm'"
                      (clicked)="deleteService(service)"
                    />
                  </div>
                </td>
              </tr>
            }
          </tbody>
        </table>
      </div>
    }
  </div>
</div>
